module.exports = __webpack_public_path__ + "static/media/qyimg.08cae32a.jpg";